import React, { FunctionComponent, useMemo, useState } from "react";
import { TutorialTimeStamp, TutorialVideo } from "../../../store/onboarding/types";
import { Accordion, Badge, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { SuperuserState } from "../../../store/superuser/types";
import LoadingIndicator from "../../common/onboarding/LoadingIndicator";

type OwnProps = {
  releaseNoteYear: number;
  activeKey?: string;
  onReleaseNoteDetail: (releaseNoteYear:string, noteId: string) => void;
  onReleaseNote: (noteYear: string) => void;
};

type Props = OwnProps;

const ReleaseNoteItem: FunctionComponent<Props> = ({ releaseNoteYear, activeKey, onReleaseNoteDetail, onReleaseNote }) => {
  const eventKey = useMemo(() => `releaseNote_${releaseNoteYear}`, [releaseNoteYear]);
  const collapsed = useMemo(() => eventKey === activeKey, [eventKey, activeKey]);

  const handleReleaseNote = (event: React.MouseEvent) => {
    event.stopPropagation();
    !collapsed ?  onReleaseNote(releaseNoteYear.toString()) : null;
  };

  const { releaseNotes, isLoading } = useSelector<ApplicationState, SuperuserState>(
    (s) => s.superuser
  );

  const numColumns = 2;

  const publishedReleaseNotes = useMemo(() =>
    releaseNotes.filter((release) => release.is_published).sort((a, b) => a.publish_date! > b.publish_date! ? -1 : 1)
  , [releaseNotes]);

  const columns = useMemo(() => {
    const colSize = Math.ceil(publishedReleaseNotes.length / numColumns);
    return Array.from({ length: numColumns }, (_, i) =>
      publishedReleaseNotes.slice(i * colSize, (i + 1) * colSize)
    );
  }, [publishedReleaseNotes]);
  

  return (
    <Card>
      <Accordion.Toggle
        as={Card.Header}
        eventKey={eventKey}
        className="d-flex align-items-center"
        onClick={handleReleaseNote}
      >
        <span className="mr-3">
          <FontAwesomeIcon
            icon={collapsed ? faCaretDown : faCaretRight}
            size="2x"
          />
        </span>
        <div>{releaseNoteYear} - Release Notes</div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body>
          {isLoading.getAllReleaseNotes ? (
            <LoadingIndicator />
          ) : collapsed ? 
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {columns.map((col, colIndex) => (
                  <ul className="list-unstyled" key={colIndex} style={{ flex: 1, marginRight: colIndex < numColumns - 1 ? '20px' : '0' }}>
                      {col.sort((a, b) => a.publish_date! > b.publish_date! ? -1: 1).map((item, rowIndex) => (
                          <li key={item.id} style={{ marginBottom: '10px' }} className="font-weight-bold">
                              <a href="javascript:void(0)" onClick={(e: React.MouseEvent) => onReleaseNoteDetail(releaseNoteYear.toString(), ''+item.id)}>{item.title}</a>
                          </li>
                      ))}
                  </ul>
              ))}
            </div> : null
          }
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export default ReleaseNoteItem;
